import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import {
  Authentication,
  Loading,
  Mockup,
  CompetencyLearning,
  CompetencyMapping,
  RoleHandler,
  VerifyAccount,
} from "./pages";

import "./App.css";
import ProtectedRoute from "./ProtectedGaurd/ProtectedRoute";
import { set_authtoken_toHeader } from "./utils/auth_token";

function App() {
  if (localStorage.getItem("token") !== null) {
    set_authtoken_toHeader(localStorage.getItem("token"));
  }
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="" element={<Mockup />} />
        <Route path="/consulting-projects" element={<CompetencyMapping />} />
        <Route
          path="/master-class-certification"
          element={<CompetencyLearning />}
        />
        <Route path="/verify-email" element={<VerifyAccount />} />
        <Route path="/authentication/*" element={<Authentication />} />
        <Route
          path="/portrayal/*"
          element={
            <ProtectedRoute>
              <RoleHandler />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
